import { FC, useCallback } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getStaffDetailPath, getStaffReturnPath, getStaffSection } from '../../../../app/router/staffNavigation';
import { useAppSelector } from "../../../../app/store/store";
import { idmService } from "../../../../entities/idm";
import { FEATURES, hasFeature } from "../../../../entities/my";
import { AccessDeniedRedirect } from "../../../../shared/ui/accessDeniedRedirect";
import { TutorPaymentDetails } from "../../../tutorPaymentDetails";
import { useStaffFeedback } from "../../model/useStaffFeedback";
import { useStaffMember } from "../../model/useStaffMember";
import { StaffDetailLayout } from "../staffDetail/StaffDetailLayout";
import idmClasses from "../../../idm/ui/idm/idmWidget.module.scss";
import classes from "./staffPaymentDetails.module.scss";

export const StaffPaymentDetailsWidget: FC = () => {
    const navigate = useNavigate()
    const {pathname, search} = useLocation()
    const section = getStaffSection(pathname)
    const backPath = getStaffReturnPath(search, section)
    const {user_id} = useParams<{user_id: string}>()
    const staffId = user_id && !Number.isNaN(Number(user_id)) ? Number(user_id) : null
    const {my} = useAppSelector(state => state.myReducer)
    const {handleError, showError} = useStaffFeedback()

    const onNotFound = useCallback(() => {
        navigate(backPath, {replace: true})
        showError('Сотрудник не найден')
    }, [backPath, navigate, showError])

    const {
        isLoading,
        loadError,
        loadStaffMember,
        staffMember,
        userPersonalData,
    } = useStaffMember({staffId, onError: handleError, onNotFound})

    const isTutorStaff = staffMember.roles.some(role => role.role_code.trim().toLowerCase() === 'tutor')
    const canUpdatePaymentDetails = staffId !== null && hasFeature(my, FEATURES.IDM.STAFF_PAYMENT_DETAILS_UPDATE, staffId)
    const canReadScheduleHistory = staffId !== null && hasFeature(my, FEATURES.AUDIT.SCHEDULE_HISTORY_READ, staffId)
    const isContentLoading = Boolean(staffId) && !loadError && (isLoading || staffMember.user_id !== staffId)
    const paymentDetails = userPersonalData?.payment_details || []

    const onEditSuccess = async () => {
        await loadStaffMember()
    }

    if(!isContentLoading && !loadError && staffId && !isTutorStaff){
        return <AccessDeniedRedirect to={getStaffDetailPath(staffId, section, search)} />
    }

    return (
        <StaffDetailLayout
            staffId={staffId}
            isLoading={isContentLoading}
            loadError={loadError}
            selectedTab={4}
            showSwitch
            showPaymentDetailsTab={isTutorStaff}
            showHistoryTab={isTutorStaff && canReadScheduleHistory}
        >
            <section className={idmClasses.panel}>
                {staffId && (
                    <>
                        <section className={classes.header}>
                            <section className={classes.title}>Платежные реквизиты</section>
                        </section>
                        <TutorPaymentDetails
                            userId={staffId}
                            canAccess
                            canEdit={canUpdatePaymentDetails}
                            initialPaymentDetails={paymentDetails}
                            savePaymentDetails={(items) => idmService.saveStaffPaymentDetails(staffId, items)}
                            onSaveSuccess={onEditSuccess}
                        />
                    </>
                )}
            </section>
        </StaffDetailLayout>
    )
}
